import axiosInstance from './axiosInstance'

type CreateCompetition = {
  file: File
  title: string
  startDateTime: string
  endDateTime: string
  description?: string
  mainPrize: string
  status: string
  secondaryPrizes?: SecondaryPrize[]
  prizeQuantity?: number
  url?: string
}

export type SecondaryPrize = {
  file: File
  title: string
  description?: string
  referralsRequired: number
  id?: string
  imageUrl?: string
}

type UpdateCompetition = CreateCompetition & { id: string }

const getAllCompetitions = () => {
  return axiosInstance.get(`/api/admin/competitions`)
}

const deleteCompetition = (id: string | number) => {
  return axiosInstance.delete(`/api/admin/competitions/${id}`)
}

const createCompetition = ({
  file,
  title,
  startDateTime,
  endDateTime,
  description,
  mainPrize,
  status,
  prizeQuantity,
  url,
  secondaryPrizes,
}: CreateCompetition) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('title', title)
  formData.append('startDateTime', startDateTime)
  formData.append('endDateTime', endDateTime)
  formData.append('description', description)
  formData.append('mainPrize', mainPrize)
  formData.append('status', status)
  formData.append('prizeQuantity', String(prizeQuantity))
  formData.append('url', url)

  secondaryPrizes.forEach((secondaryPrize, index) => {
    formData.append(`secondaryPrizes[${index}][file]`, secondaryPrize.file)
    formData.append(`secondaryPrizes[${index}][title]`, secondaryPrize.title)
    formData.append(
      `secondaryPrizes[${index}][description]`,
      secondaryPrize.description
    )
    formData.append(
      `secondaryPrizes[${index}][referralsRequired]`,
      String(secondaryPrize.referralsRequired)
    )
  })

  return axiosInstance.post(`/api/admin/competitions`, formData)
}

const editCompetition = ({
  id,
  file,
  title,
  startDateTime,
  endDateTime,
  description,
  mainPrize,
  status,
  secondaryPrizes,
  prizeQuantity,
  url,
}: UpdateCompetition) => {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }

  formData.append('title', title)
  formData.append('startDateTime', startDateTime)
  formData.append('endDateTime', endDateTime)
  formData.append('description', description)
  formData.append('mainPrize', mainPrize)
  formData.append('status', status)
  formData.append('prizeQuantity', String(prizeQuantity))
  formData.append('url', url)

  secondaryPrizes.forEach((secondaryPrize, index) => {
    formData.append(`secondaryPrizes[${index}][file]`, secondaryPrize.file)
    formData.append(`secondaryPrizes[${index}][title]`, secondaryPrize.title)
    formData.append(
      `secondaryPrizes[${index}][description]`,
      secondaryPrize.description
    )
    formData.append(
      `secondaryPrizes[${index}][referralsRequired]`,
      String(secondaryPrize.referralsRequired)
    )
    formData.append(
      `secondaryPrizes[${index}][imageUrl]`,
      String(secondaryPrize.imageUrl)
    )
  })

  return axiosInstance.put(`/api/admin/competitions/${id}`, formData)
}

const competitionsApi = {
  getAllCompetitions,
  deleteCompetition,
  createCompetition,
  editCompetition,
}

export default competitionsApi
